var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMdGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbc05;}.cls-2{fill:#ea4335;}.cls-3{fill:#34a853;}.cls-4{fill:#4285f4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.33,16h0a19.24,19.24,0,0,0,0,16.88L14.74,28a11.22,11.22,0,0,1,0-7.06l-.31-.25L8.33,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,16h0l6.1,4.66.31.25a11.23,11.23,0,0,1,10.69-7.73,11,11,0,0,1,2.9.39,10.81,10.81,0,0,1,2.6,1.08c.27.15.53.32.78.49s.5.36.74.56L38,10.15a20,20,0,0,0-2-1.53c-.46-.31-.94-.61-1.43-.88s-1-.52-1.51-.75l-.78-.32a18.38,18.38,0,0,0-3.3-1c-.29-.06-.58-.1-.87-.14a18,18,0,0,0-2.67-.19A19,19,0,0,0,8.33,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.43,43.5a18.14,18.14,0,0,0,12.42-4.75L31.76,34a11.81,11.81,0,0,1-6.33,1.66A11.22,11.22,0,0,1,14.74,28L8.33,32.88A19,19,0,0,0,25.43,43.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.62,24.44A15.83,15.83,0,0,0,43.19,21H25.43v7.36H35.65A8.6,8.6,0,0,1,31.76,34l6.09,4.71C41.35,35.5,43.62,30.66,43.62,24.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdGoogle);
export default __webpack_public_path__ + "static/media/Icon-MD-Google.9174b89222ed18afba71cd1bc3bf17b5.svg";
export { ForwardRef as ReactComponent };